import { createApiHandler } from './handler';

const diets = {
  apiClient: null,
  path: '/admin/diets',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async printMeal(id) {
    try {
      const response = await this.apiClient.post(`/franchises/diets/print-meal/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async printAllMeals(dietId) {
    try {
      const response = await this.apiClient.post(`/franchises/diets/print-all-meals/${dietId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default diets;
